"use server";

import { revalidatePath } from "next/cache";
import { redirect } from "next/navigation";
import { auth } from "@/auth";
import { prisma } from "@/lib/prisma";

const allowedStatuses = [
  "PENDING",
  "PAID",
  "PREPARING",
  "SHIPPED",
  "COMPLETED",
  "CANCELLED",
] as const;

function getOrderStatusLabel(status: string) {
  switch (status) {
    case "PENDING":
      return "En attente";
    case "PAID":
      return "Payée";
    case "PREPARING":
      return "En préparation";
    case "SHIPPED":
      return "Expédiée";
    case "COMPLETED":
      return "Terminée";
    case "CANCELLED":
      return "Annulée";
    default:
      return status;
  }
}

export async function updateOrderStatus(
  _prevState: { ok?: boolean; message?: string },
  formData: FormData
) {
  const session = await auth();

  if (!session?.user) {
    redirect("/connexion?callbackUrl=/admin/commandes");
  }

  if (session.user.role !== "ADMIN") {
    redirect("/compte");
  }

  const orderId = String(formData.get("orderId") || "");
  const status = String(formData.get("status") || "");

  if (
    !orderId ||
    !allowedStatuses.includes(status as (typeof allowedStatuses)[number])
  ) {
    return {
      ok: false,
      message: "Statut invalide.",
    };
  }

  await prisma.order.update({
    where: { id: orderId },
    data: {
      status: status as
        | "PENDING"
        | "PAID"
        | "PREPARING"
        | "SHIPPED"
        | "COMPLETED"
        | "CANCELLED",
    },
  });

  revalidatePath("/admin/commandes");

  return {
    ok: true,
    message: `Statut mis à jour : ${getOrderStatusLabel(status)}.`,
  };
}

export async function deleteOrder(formData: FormData) {
  const session = await auth();

  if (!session?.user) {
    redirect("/connexion?callbackUrl=/admin/commandes");
  }

  if (session.user.role !== "ADMIN") {
    redirect("/compte");
  }

  const orderId = String(formData.get("orderId") || "");

  if (!orderId) {
    return {
      ok: false,
      message: "Commande introuvable.",
    };
  }

  await prisma.order.delete({
    where: { id: orderId },
  });

  revalidatePath("/admin/commandes");

  return {
    ok: true,
    message: "Commande supprimée.",
  };
}